export const LineItemStatus = {
	NONE: 0,
	PRE_ORDERED: 1,
	ORDERED: 2,
	CLAIMED: 3,
	PREPARED: 4,
	STAGED: 5,
	DELIVERED: 6,
	CANCELLED: 7
} as const;
export type TLineItemStatus = typeof LineItemStatus[keyof typeof LineItemStatus];
